import React, { useContext, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@nextui-org/react";

import closeIcon from "../../Assets/popup/cross-square.svg";
import { ArchiveContext } from "Context/ArchiveContext";
import { PopUpContext } from "Context/PopUpContext";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function ArchiveModal({
  isOpen,
  onClose,
  stopClosePropagation,
  frondId,
  projects,
  flag,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const { setArchiveProjects } = useContext(ArchiveContext);

  const handleClose = (e) => {
    if (stopClosePropagation) {
    }
    setArchiveProjects([]);
    onClose();
  };

  const authToken = localStorage.getItem("token");

  const { setIsArchiveProject, setIsEditTitle } = useContext(PopUpContext);

  const archiveProject = async () => {
    setIsLoading(true);
    setIsDisabled(true);

    if (!frondId) return;
    try {
      const { data } = await axios.delete(
        `/projects/${frondId}/archive`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      setIsArchiveProject(true);
      onClose();
      setTimeout(() => {
        setIsArchiveProject(false);
      }, 1000);
      toast("Project Archived", {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast success-toast",
      });
      if (flag) {
        setIsEditTitle(true);

        setTimeout(() => {
          setIsEditTitle(false);
        }, 1000);
      }
    } catch (error) {
      toast(error?.response?.data?.message, {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast error-toast",
      });
    }
    setIsLoading(false);
    setIsDisabled(false);
  };

  const archiveProjects = async () => {
    setIsLoading(true);
    setIsDisabled(true);

    for (let i = 0; i < projects.length; i++) {
      try {
        const { data } = await axios.delete(
          `/projects/${projects[i]}/archive`,
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (i === projects.length - 1) {
          toast("Projects Archived", {
            autoClose: 1500,
            position: "bottom-right",
            hideProgressBar: true,
            className: "rounded-4xl custom-toast success-toast",
          });
          setIsArchiveProject(true);
          setTimeout(() => {
            setIsArchiveProject(false);
          });
          handleClose();
          setArchiveProjects([]);
        }
      } catch (error) {
        toast(error?.response?.data?.message, {
          autoClose: 1500,
          position: "bottom-right",
          hideProgressBar: true,
          className: "rounded-4xl custom-toast error-toast",
        });
      }
    }
    setIsLoading(false);
    setIsDisabled(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={() => {
        onClose();
        setArchiveProjects([]);
      }}
      placement="center"
      backdrop="opaque"
      classNames={{
        backdrop: "z-[9999]",
        wrapper: "z-[99999]",
        footer: "justify-center items-center py-5",
        body: "border-b-1 border-solid border-grayBorder pt-2 pb-4",
        closeButton: "hidden",
        base: "p-5 confirm-modal",
      }}
      hideCloseButton={true}
      onClick={(e) => e.stopPropagation()}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex items-center justify-end">
              <button onClick={handleClose} className="" aria-label="Close">
                <img src={closeIcon} alt="Close" className="w-6 h-6" />
              </button>
            </ModalHeader>
            <ModalBody>
              <p className="text-cardGrayColor font-bold text-center leading-[18.4px] sm:w-[256px] mx-auto">
                {projects?.length > 0
                  ? projects?.length > 1
                    ? "Are you sure you want to archive those projects?"
                    : "Are you sure you want to archive this project?"
                  : "Are you sure you want to archive this project?"}
              </p>
            </ModalBody>
            <ModalFooter className="flex items-center justify-center gap-2.5">
              <button
                onClick={() => {
                  handleClose();
                  setArchiveProjects([]);
                }}
                className="text-base font-bold leading-[18.4px] flex justify-center items-center rounded-[27px] py-[11px] px-[25px] w-[100px] h-[39px] gradiantBorder no-focus smallBorder"
              >
                <span className="text-transparent bg-mainGradiant bg-clip-text font-normal text-base">
                  Cancel
                </span>
              </button>
              <button
                disabled={isDisabled}
                onClick={() => {
                  if (projects?.length > 0) {
                    archiveProjects();
                  } else {
                    archiveProject();
                  }
                }}
                className="text-base font-bold leading-[18.4px] text-white flex justify-center items-center bg-mainGradiant rounded-[27px] py-[11px] px-[25px] w-[100px] h-[39px]"
              >
                {isLoading ? (
                  <span className="flex gap-2 justify-center items-center text-white">
                    <i className="fa-solid fa-spinner fa-spin"></i>
                  </span>
                ) : (
                  "Archive"
                )}
              </button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
